// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"445":"b8d3e253","595":"ced475b9","775":"cf584965","787":"e46deee9"}[chunkId] + ".chunk.js";
};